type Props = {
  className?: string
}

export const LockIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className={className ?? 'w-4 h-4'}
      aria-hidden="true"
    >
      <path
        d="M8 10V8a4 4 0 1 1 8 0v2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5"
        y="10"
        width="14"
        height="10"
        rx="2"
        ry="2"
      />
      <path
        d="M12 14v3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

